// i18n area 'tasks' — locale ru-RU (task #171, onda 3): tradotto DALL'ITALIANO,
// che è la lingua SORGENTE (regola ratificata 2026-08-03); gli anglicismi del
// sorgente si TRASLANO, non si traducono. Sidecar anti-stantie: ../meta/tasks.ru-RU.meta.json.
import type { enUS } from './tasks'

export const ruRU: typeof enUS = {
  macrotasks: {
    title: 'Макрозадачи',
    subtitle: 'Составные операции — их можно возобновить с неудавшегося шага или прервать',
    colType: 'Тип',
    colTarget: 'Объект',
    colPhase: 'Фаза',
    colSteps: 'Шаги',
    empty: 'Макрозадач нет',
    detail: 'Детали',
    failedAt: 'сбой на',
    resume: 'Повторить с неудавшегося шага',
    abort: 'Прервать все',
    cancel: 'Отменить',
    actionError: 'Действие отклонено'
  },
  tasks: {
    title: 'Задачи',
    searchPlaceholder: 'Поиск по типу или цели',
    type: 'Тип',
    target: 'Цель',
    phaseLabel: 'Фаза',
    progress: 'Ход выполнения',
    started: 'Начата',
    finished: 'Завершена',
    node: 'Узел',
    empty: 'Задач нет',
    loadError: 'Не удалось загрузить задачи — доступен ли бэкенд TVirt?',
    limboHint: "Узел '{node}' недоступен с {time} — задача удерживает аренду на запись для своей цели, пока узел не вернется или его выключение не будет подтверждено",
    nodeAttested: 'Выключение узла подтверждено',
    phase: {
      queued: 'В очереди',
      running: 'Выполняется',
      succeeded: 'Выполнена',
      failed: 'Ошибка',
      cancelled: 'Отменена',
      'failed-at-step': 'Ошибка на шаге',
      aborted: 'Прервана'
    },
    dropdown: {
      tooltip: 'Текущие задачи',
      title: 'Текущие задачи',
      empty: 'Текущих задач нет',
      viewAll: 'Все задачи'
    },
    detail: {
      open: 'Детали',
      scope: 'Область',
      message: 'Сообщение',
      params: 'Параметры',
      result: 'Результат',
      errorTitle: 'Ошибка',
      steps: 'Шаги',
      failedAt: 'сбой на',
      superseded: 'заменен',

      // Стандартный диалог (раунд #156): место дочерней задачи в плане родителя,
      // сам родитель (открывается на месте) и шаг, на котором произошел сбой.
      step: 'Шаг',
      parent: 'Родительская задача',
      failedStep: 'Неудавшийся шаг',
      log: 'Журнал',
      logEmpty: 'Записей в журнале пока нет',
      close: 'Закрыть'
    },
    actions: {
      cancel: 'Отменить',
      resume: 'Повторить с неудавшегося шага',
      abort: 'Прервать все (откат выполненных шагов)',
      refused: 'Действие отклонено'
    }
  },
  events: {
    loadError: 'Не удалось загрузить журнал — бэкенд TVirt доступен?',
    title: 'События',
    subtitle: 'Историческая память кластера: свершившиеся факты, от новых к старым',
    filterSeverity: 'Важность',
    filterCategory: 'Категория',
    filterAll: 'Все',
    searchLabel: 'Поиск',
    searchPlaceholder: 'Искать во всём журнале',
    subjectFilter: 'События {subject} — показать все',
    colAt: 'Когда',
    colSeverity: 'Важность',
    colType: 'Тип',
    colSubject: 'Объект',
    colActor: 'Кто',
    colNode: 'Node',
    colMessage: 'Сообщение',
    empty: 'Событий нет',
    loadMore: 'Загрузить ещё',
    actorSystem: 'система',
    detailScope: 'Scope',
    detailTask: 'Task',
    detailId: 'ID события',
    taskCollectedHint: 'У task более короткое хранение: после сборки ссылка перестаёт отвечать',
    severity: {
      info: 'Информация',
      warning: 'Предупреждение',
      error: 'Ошибка',
      critical: 'Критично'
    },
    category: {
      lifecycle: 'Жизненный цикл',
      config: 'Конфигурация',
      availability: 'Доступность',
      security: 'Безопасность'
    },
    type: {
      haNetsvcFailedOver: 'Аварийное переключение сетевой службы',
      haNetsvcNoCandidate: 'Сетевая служба без узла-кандидата',
      haNetsvcReaped: 'Локальный экземпляр пожат при возвращении',
      netsvcFloatipMoved: 'Плавающий IP перешёл к другому держателю',
      netsvcFloatipNoHolder: 'Плавающий IP без здоровой цели',
      haAppFailedOver: 'Failover экземпляра App',
      haAppNoCandidate: 'Экземпляр App без узла-кандидата',
      haAppStorageLocalSkip: 'Экземпляр App не перенесён: постоянные данные локальны для мёртвого узла',
      haAppReaped: 'Локальный под экземпляра App убран при возвращении'
    }
  },
  audit: {
    loadError: 'Не удалось загрузить журнал аудита — бэкенд TVirt доступен?',
    title: 'Аудит',
    subtitle: 'Кто что сделал, когда и над каким объектом — попытки действий, включая отказы',
    filterOutcome: 'Исход',
    filterAll: 'Все',
    filterSudo: 'Только действия с повышением прав',
    colAt: 'Когда',
    colActor: 'Кто',
    colAction: 'Действие',
    colTarget: 'Объект',
    colOutcome: 'Исход',
    colNode: 'Node',
    empty: 'Действий не записано',
    loadMore: 'Загрузить ещё',
    sudoBadge: 'sudo',
    tokenBadge: 'app token',
    detailScope: 'Scope',
    detailPath: 'Маршрут',
    detailProblem: 'Причина',
    detailTask: 'Task',
    detailClientIp: 'Откуда',
    detailId: 'ID записи',
    detailSession: 'Сеанс',
    taskHint: 'Исход принятого действия живёт в журнале событий, под тем же id task',
    outcome: {
      succeeded: 'Выполнено',
      accepted: 'Принято',
      denied: 'Отказано',
      rejected: 'Отклонено',
      failed: 'Сбой'
    }
  },
  notifications: {
    loadError: 'Не удалось загрузить уведомления — бэкенд TVirt доступен?',
    actionError: 'Действие отклонено',
    title: 'Уведомления',
    subtitle: 'Назначения, к которым факты журнала покидают кластер',
    rulesTitle: 'Правила',
    rulesSubtitle: 'Какие факты выходят и куда',
    deliveriesTitle: 'Доставки',
    deliveriesSubtitle: 'Результат каждого уведомления с причиной, когда оно не удаётся',
    colName: 'Имя',
    colKind: 'Тип',
    colWhere: 'Куда',
    colScope: 'Scope',
    colSeverity: 'Важность',
    colMatch: 'Фильтр',
    colTargets: 'Назначение',
    colAt: 'Когда',
    colState: 'Состояние',
    colEvent: 'Событие',
    colAttempts: 'Попытки',
    colOutcome: 'Результат',
    empty: 'Нет строк',
    matchAll: 'все факты',
    test: 'Проверить',
    testOk: 'Тестовое уведомление доставлено в {target}',
    testFailed: 'Проверка в {target} не удалась: {reason}',
    retry: 'Вернуть в очередь',
    retried: 'Доставка возвращена в очередь',
    grouped: 'и ещё {count} повторений',
    state: {
      failed: 'Не доставлено',
      pending: 'В очереди',
      sending: 'Отправляется',
      sent: 'Отправлено'
    },
    tabTargets: 'Назначения',
    tabRules: 'Правила',
    tabDeliveries: 'Доставки',
    targetCreateTitle: 'Новое назначение',
    ruleCreateTitle: 'Новое правило',
    nameHint: 'Строчные буквы, цифры и дефисы; уникально в пределах области',
    kindImmutableHint: 'Неизменяемо: смена типа означает создание другого назначения',
    kindSmtp: 'Почта (SMTP)',
    kindWebhook: 'Webhook',
    enabled: 'Состояние',
    enabledOn: 'Активно',
    enabledOff: 'Приостановлено',
    smtpHost: 'SMTP-сервер',
    smtpPort: 'Порт',
    smtpPortHint: 'Обычно: 25 без TLS, 587 со starttls, 465 с tls',
    smtpSecurity: 'Безопасность',
    smtpFrom: 'Отправитель',
    smtpTo: 'Получатели',
    smtpToHint: 'Один или несколько адресов через запятую',
    webhookUrl: 'URL',
    payload: 'Содержимое',
    payloadHint: 'При minimal сообщение и данные события не покидают кластер',
    credential: 'Учётные данные',
    credentialNone: 'Нет',
    credentialHintSmtp: 'Учётная запись релея из хранилища ключей; нет означает анонимный SMTP',
    credentialHintWebhook: 'Секрет подписи из хранилища ключей; без подписи любой, кто знает URL, может выдать себя за кластер',
    minSeverityHint: 'Порог, а не множество: от этой важности и выше',
    categories: 'Категории',
    categoriesHint: 'Пусто = все',
    types: 'Типы событий',
    typesHint: 'Через запятую; пусто = все. Неизвестный тип отклоняется',
    targetsHint: 'Хотя бы одно; они должны находиться в области правила или в её предке',
    recursiveOn: 'Также дочерние области',
    recursiveOff: 'Только эта область',
    recursiveHint: 'Ресурсы живут в листьях: без потомков правило на корне уведомляет почти ни о чём',
    repeatWindow: 'Окно группировки (с)',
    repeatWindowHint: 'Внутри окна повторы не отправляют почту: они считаются на первом. 0 отключает',
    targetInUseError: 'Назначение {name} всё ещё используется правилом'
  }
}
